export default {

    // 设置前一个路由
    setPreviousRoute(state, previousRoute) {
        state.previousRoute = previousRoute
    }

}